import { loginRequest, directLineEndpointConfig } from "../authConfig";
import { msalInstance } from "../index";

export async function callMw() {
    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    const response = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account
    });

    const headers = new Headers();
    const bearer = `Bearer ${response.accessToken}`;
    headers.append("Authorization", bearer);

    const options = {
        mode: 'cors' as RequestMode,
        method: "POST",
        headers: headers
    };

    return fetch(directLineEndpointConfig.directLineTokenEndpoint, options)
        .then(response =>  
            response.text()
        
            )
        .catch(error => console.log(error));
}